<template>
  <div
    :data-test-id="testId"
    class="tw-z-[55] tw-w-80 tw-rounded-md tw-border-2 tw-p-3"
    role="alert"
    :class="{
      'tw-border-system-success-500 tw-bg-system-success-50':
        props.variant === 'success',
      'tw-border-system-error-500 tw-bg-system-error-50':
        props.variant === 'danger',
      'tw-border-branding-blue-500 tw-bg-branding-blue-50':
        props.variant === 'info',
    }"
  >
    <div class="tw-flex tw-justify-between tw-items-center tw-gap-3 tw-mb-1">
      <div class="tw-size-6">
        <ClIconTablerCircleCheck
          v-if="props.variant === 'success'"
          class="tw-text-system-success-500"
        />
        <ClIconTablerExclamationCircle
          v-else-if="props.variant === 'danger'"
          class="tw-text-system-error-500"
        />
        <ClIconTablerInfoCircle
          v-else-if="props.variant === 'info'"
          class="tw-text-branding-blue-500"
        />
      </div>
      <div
        class="tw-flex-grow tw-overflow-hidden tw-whitespace-normal tw-break-words"
      >
        <div
          class="tw-text-lg tw-font-medium"
          :data-test-id="`${testId}-title`"
        >
          {{ title }}
        </div>
      </div>
      <button
        class="tw-inline-flex"
        aria-label="Close"
        :data-test-id="`${testId}-close-button`"
        @click="emitCloseBtnClick(id)"
      >
        <ClIconTablerX />
      </button>
    </div>
    <div
      class="tw-text-sm tw-ml-9 tw-overflow-auto"
      :data-test-id="`${testId}-message`"
    >
      <slot>{{ message }}</slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  ClIconTablerInfoCircle,
  ClIconTablerX,
  ClIconTablerCircleCheck,
  ClIconTablerExclamationCircle,
} from "@cl/components/icons";

export interface Props {
  id: string;
  title: string;
  message: string;
  variant?: "success" | "danger" | "info";
  testId?: string;
}

const props = withDefaults(defineProps<Props>(), {
  variant: "success",
  testId: "cl-toast",
});

const emit = defineEmits<{
  (event: "on-close", id: string): void;
}>();

const emitCloseBtnClick = (id: string): void => {
  emit("on-close", id);
};
</script>
